/**
 * Created by vladislav on 10/08/2023
 */

const GuideComponent = function (unit) { 
    UnitComponent.call(this, unit);
};

GuideComponent.prototype = Object.create(UnitComponent.prototype);
GuideComponent.prototype.constructor = GuideComponent;

GuideComponent.prototype.handleClick = function () {
    const guideOptions = this.unit.getData().guide;

    cleverapps.focusManager.display({
        focus: "GuideWindow",
        action: function (f) {
            new GuideWindow(guideOptions);

            cleverapps.focusManager.onceNoWindowsListener = f;
        }
    });
    return true;
};